export default {
  gamifications: [],
  pagination: {},
  gamification: {}
}
